import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';
import { ChoiceButton, ChoiceType } from 'components/choice-button';

export const WorkoutPlace = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageValue: wellnessGoal, setPageValue }: any = useLocalStorage({
        key: LocalStorageKeys[RoutePath.WorkoutPlace],
        defaultValue: '',
    });

    const { pageConfiguration } = useContext(BaseContext);

    const handleClick = (answer: ChoiceType) => {
        saveAnswers({
            key: 'workout-place',
            itemQuestion: { question: t('workout-place-title'), value: t(answer.value) },
        });

        setPageValue(answer.key);

        pageConfiguration.handleOnPageComplete(answer.value);
    };

    const answers: ChoiceType[] = [
        {
            key: 'gym',
            value: t('workout-place-option-gym'),
        },
        {
            key: 'home',
            value: t('workout-place-option-home'),
        },
        {
            key: 'studio',
            value: t('workout-place-option-studio'),
        },
        {
            key: 'outdoor',
            value: t('workout-place-option-outdoor'),
        }
    ];

    return (
        <>
            <Typography variant={TypographyVariants.h1}>{t('workout-place-title')}</Typography>

            {answers.map((v: ChoiceType) => (
                <ChoiceButton
                    key={v.key}
                    center={true}
                    selected={v.key === wellnessGoal}
                    typographyText={v.value}
                    onClick={() => handleClick(v)}
                />
            ))}
        </>
    );
};
